export const mockProjects = [
  {
    id: 1,
    projectName: "Downtown Office Complex",
    jobNumber: "2024-001",
    modelingStatus: "In Progress",
    billingStatus: "Pending",
    dueDate: "2024-09-15"
  },
  {
    id: 2,
    projectName: "Residential Tower A",
    jobNumber: "2024-002",
    modelingStatus: "Complete",
    billingStatus: "Invoiced",
    dueDate: "2024-08-30"
  },
  {
    id: 3,
    projectName: "Shopping Center Renovation",
    jobNumber: "2024-003",
    modelingStatus: "Not Started",
    billingStatus: "Not Started",
    dueDate: "2024-10-20"
  },
  {
    id: 4,
    projectName: "Hospital Wing Extension",
    jobNumber: "2024-004",
    modelingStatus: "In Progress",
    billingStatus: "Partial",
    dueDate: "2024-11-05"
  },
  {
    id: 5,
    projectName: "University Science Building",
    jobNumber: "2024-005",
    modelingStatus: "Complete",
    billingStatus: "Paid",
    dueDate: "2024-07-15"
  },
  {
    id: 6,
    projectName: "Warehouse Distribution Center",
    jobNumber: "2024-006",
    modelingStatus: "In Progress",
    billingStatus: "Pending",
    dueDate: "2024-09-30"
  }
];

export const statusOptions = {
  modelingStatus: [
    'Startup', 'Data Prep',
    'Ready to Model', 'Modeling', 'Double Check', 'Corrections', 'Review',
    'Ready to Export', 'Utilities', 'Completed'
  ],
  modelingState: ['Active', 'Hold', 'High Priority', 'Completed'],
  billingStatus: ['Quoted', 'Invoiced', 'Paid', 'Voided'],
  agreementStatus: ['Ready', 'Utility Ready', 'Sent', 'Completed', 'None needed', 'Revision-none', 'Voided', 'Hold', 'Not Signed'],
  readyForStatus: [
    'Ready for Data Prep',
    'Ready to Model', 'Ready for Double Check', 'Ready for Corrections',
    'Ready for Review', 'Ready to Export', 'Ready for Utilities'
  ]
};

export const modelBuilders = [
  { id: 1, name: 'John Smith', color: '#3b82f6', initials: 'JS' },
  { id: 2, name: 'Sarah Johnson', color: '#ef4444', initials: 'SJ' },
  { id: 3, name: 'Mike Davis', color: '#10b981', initials: 'MD' },
  { id: 4, name: 'Lisa Brown', color: '#f59e0b', initials: 'LB' },
  { id: 5, name: 'Tom Wilson', color: '#8b5cf6', initials: 'TW' }
];